import { useMutation, useQuery } from '@tanstack/react-query'
import axios, { AxiosError } from 'axios'

import { processApiError } from 'src/common/utils'
import { AddSurveyAnswersDto, GetSurveysDto, Survey } from '../types'

const backendUrl = process.env.REACT_APP_MEDPORTAL_API_URL

// GET ONE SURVEY
export const getSurvey = async (surveyId: number) => {
  if (!surveyId) {
    throw new Error('the survey ID was not provided')
  }
  return axios
    .get(`${backendUrl}/api/v1/medportal/assessments/${surveyId}`, { withCredentials: true })
    .then((response) => response.data)
}

export const useSurvey = (surveyId: number, enabled = true) => {
  return useQuery<Survey, AxiosError>(['survey', surveyId], () => getSurvey(surveyId), {
    onError: (err) => processApiError('Unable to fetch survey', err),
    enabled,
  })
}

export const getSurveys = async (attrs: GetSurveysDto) => {
  if (!attrs.orgIds?.length) {
    return { surveys: [], totalCount: 0 }
  }
  return axios
    .post(`${backendUrl}/api/v1/medportal/assessments/get`, attrs, { withCredentials: true })
    .then((response) => response.data)
}
export const useSurveys = (attrs: GetSurveysDto, enabled = true) => {
  return useQuery<Survey[], AxiosError>(['surveys', attrs], () => getSurveys(attrs), {
    keepPreviousData: true,
    onError: (err) => processApiError('Unable to fetch surveys', err),
    enabled,
    staleTime: 1000,
  })
}

export const addSurveyAnswers = (args: AddSurveyAnswersDto) => {
  return axios
    .post(`${backendUrl}/api/v1/medportal/assessments/add`, args, { withCredentials: true })
    .then((response) => response.data)
}

export const useSurveyAnswers = () => {
  return useMutation<Survey, AxiosError, AddSurveyAnswersDto, () => void>((a: AddSurveyAnswersDto) => addSurveyAnswers(a), {
    onError: (err) => processApiError('Unable to add survey answers', err),
  })
}
